import { Component, input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ERROR_MESSAGES } from '@shared/components/input/errors';
import { InputPatternDirective } from '@shared/directives/input-pattern.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    InputPatternDirective,
    TranslateModule,
  ],
})
export class InputComponent implements ControlValueAccessor {
  type = input<string>('text');
  title = input.required<string>();
  placeholder = input<string>('Enter value');
  required = input<boolean>(false);
  max = input<number>(200);
  pattern = input<RegExp>(/./);
  pastePattern = input<RegExp>(/./);
  autocomplete = input<string>();
  // FOR INPUT TO VALIDATE ONLY AFTER SUBMIT
  isSubmitRequired = input<boolean>(false);
  isSubmitted = input<boolean>(false);


  value: string = '';
  touched = false;
  disabled = false;
  errors = [];
  listOfErrors = ERROR_MESSAGES;

  constructor(@Self() @Optional() protected control: NgControl) {
    if (control) {
      control.valueAccessor = this;
    }
  }

  get inputErrors(): string[] | null {
    if (this.control.errors) {
      return Object.keys(this.control.errors);
    }
    return null;
  }

  get invalid(): boolean {
    // @ts-ignore
    return this.control ? this.control.invalid : false;
  }

  get showError(): boolean {
    if (!this.control) {
      return false;
    }
    if (this.isSubmitRequired() && !this.isSubmitted()) {
      return false;
    }

    const { dirty, touched } = this.control;
    // @ts-ignore
    return this.invalid ? (dirty || touched) : false;
  }

  inputHandler($event: Event): void {
    const value = ($event.target as HTMLInputElement).value;
    this.touched = true;

    this.onChange(value);
    this.onTouch();
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange: any = () => {
  };
  onTouch: any = () => {
  };
}
